import { render } from "./MyComments.vue?vue&type=template&id=506d0161&scoped=true"
import script from "./MyComments.vue?vue&type=script&lang=js"
export * from "./MyComments.vue?vue&type=script&lang=js"

import "./MyComments.vue?vue&type=style&index=0&id=506d0161&lang=scss&scoped=true"

import exportComponent from "D:\\gw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-506d0161"]])

export default __exports__